import ChangelogView from './ChangelogView';
import { Helmet } from 'react-helmet-async';
import { Paper } from '@mui/material';
import { useEffect } from 'react';
import useParameters from '../../hooks/useParameters';

const sortList = (list) => {
  return list.sort((a, b) => new Date(b.date) - new Date(a.date));
};

export default function Novedades() {
  const { changelog } = useParameters();
  const changelogDateSort = sortList(changelog ?? []);
  const lastSeenUpgrade = changelog?.length
    ? localStorage.getItem('lastSeenUpgrade') || changelogDateSort[0].date
    : null;

  useEffect(() => {
    if (changelogDateSort.length) {
      const timer = setTimeout(() => {
        localStorage.setItem('lastSeenUpgrade', changelogDateSort[0].date);
      }, 1000);
      localStorage.setItem('badgeVisible', changelogDateSort[0].date);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [changelog]);

  return (
    <>
      <Helmet>
        <title>Novedades | Fintecsol Factoring</title>
      </Helmet>
      <Paper
        sx={{
          width: { sm: '100vw', md: '95vw', lg: '80vw' },
          mx: 'auto',
          mt: 12,
          p: 4,
          backgroundColor: 'background.paper',
        }}
      >
        <ChangelogView data={changelog} lastSeenUpgrade={lastSeenUpgrade} />
      </Paper>
    </>
  );
}
